module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"permissions-modal\" title=\"App Permissions\" style=\"display: none; margin-left:5px;\">\r\n<div class=\"form-group\">\r\n    <div class=\"row nopadding\">\r\n        <div class=\"col-sm-12\" style=\"margin-bottom: 1em;\">\r\n            ")
    ;  if(!isReport){ 
    ; __append("\r\n            <label><input style=\"margin-right:3px;\" type=\"checkbox\" name=\"currentRequireLoginFromEmail\"/>Require Login From Notification Email Link</label>\r\n            ")
    ;   } 
    ; __append("\r\n        </div>\r\n    </div>\r\n    <div class=\"row nopadding\">\r\n        <div class=\"col-sm-12\">\r\n            <span>Can Be Viewed By</span> \r\n            <select name=\"permissions\" class=\"permissions-list show-scroll-bar-y\" size=\"5\">\r\n            </select>\r\n        </div>\r\n    </div>\r\n    <div class=\"row nopadding\">\r\n        <div class=\"col-sm-12\">\r\n            <button id=\"addPermissionForm\" title=\"Add Permission\" class=\"btn btn-default hvr-glow tbl-icon\"><i class=\"fa pf-add\"></i></button>\r\n            <button id=\"removePermissionForm\" title=\"Remove Permission\" class=\"btn btn-default hvr-glow tbl-icon\"><i class=\"fa pf-delete icon-gradient\"></i></button>\r\n        </div>\r\n    </div>\r\n</div>\r\n<div class=\"hide\" id=\"sharedPermissions\">\r\n    <!--Specific Permissions go Here-->\r\n    shared permissions\r\n</div>\r\n</div>")
  }
  return __output;

}